import { render, staticRenderFns } from "./crudSource.vue?vue&type=template&id=08f10888"
import script from "./crudSource.vue?vue&type=script&lang=js"
export * from "./crudSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports